export enum TriggerButtonColorMode {
  Light = 'light',
  Dark = 'dark',
}
